import { useId, useMemo } from 'preact/hooks';
import { encode } from 'uqr';

export interface QrCodeProps {
  text: string;
  /** Accessible description of what the code contains. */
  label: string;
  class?: string;
}

/** QR code as an SVG (one path for all dark modules: small DOM, crisp at any size). */
export function QrCode({ text, label, class: className }: QrCodeProps) {
  const titleId = useId();
  const { path, size } = useMemo(() => qrPath(text), [text]);
  return (
    <svg
      class={className}
      viewBox={`0 0 ${size} ${size}`}
      role="img"
      aria-labelledby={titleId}
      shape-rendering="crispEdges"
    >
      <title id={titleId}>{label}</title>
      <rect width={size} height={size} fill="#ffffff" />
      <path d={path} fill="#0a0614" />
    </svg>
  );
}

/** SVG path data with a 1x1 square per dark module, plus the matrix size (quiet zone included). */
export function qrPath(text: string): { path: string; size: number } {
  const qr = encode(text, { ecc: 'M', border: 2 });
  const parts: string[] = [];
  qr.data.forEach((row, y) => {
    row.forEach((dark, x) => {
      if (dark) parts.push(`M${x} ${y}h1v1h-1z`);
    });
  });
  return { path: parts.join(''), size: qr.size };
}
